import React from 'react';
import { motion } from 'framer-motion';
import { CalendarClock, Activity, Zap, Share2 } from 'lucide-react';
export function Slide20Workflow() {
  const workflow = [{
    phase: 'Before congress',
    icon: CalendarClock,
    action: 'Prepare email template, LinkedIn post structure, and mini-report layout.',
    color: 'bg-slate-100 text-slate-600 border-slate-200'
  }, {
    phase: 'During congress',
    icon: Activity,
    action: 'Collect responses and monitor engagement daily.',
    color: 'bg-minerva-blue/10 text-minerva-blue border-minerva-blue/20'
  }, {
    phase: 'Immediately after',
    icon: Zap,
    action: 'Publish a short insight summary within 3–5 working days.',
    color: 'bg-emerald-50 text-emerald-600 border-emerald-100'
  }, {
    phase: 'After publishing',
    icon: Share2,
    action: 'Use the insight asset for lead nurturing, rep follow-up, and LinkedIn thought leadership.',
    color: 'bg-indigo-50 text-indigo-600 border-indigo-100'
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full justify-center" data-id="element-557">
      <div className="mb-16 text-center" data-id="element-558">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-559">
          Build the insight asset before launch
        </h2>
        <p className="text-xl text-slate-500 max-w-3xl mx-auto" data-id="element-560">
          To capitalize faster next time, the follow-up content should be
          planned before the congress starts.
        </p>
      </div>

      <div className="relative" data-id="element-561">
        {/* Connecting Line */}
        <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-slate-100 -translate-y-1/2 z-0" data-id="element-562" />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10" data-id="element-563">
          {workflow.map((step, i) => {
          const Icon = step.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + i * 0.15
          }} className="flex flex-col items-center text-center" data-id="element-564">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 border-2 ${step.color} bg-white shadow-sm`} data-id="element-565">
                  <Icon className="w-7 h-7" data-id="element-566" />
                </div>
                <h3 className="text-lg font-bold text-slate-800 mb-3" data-id="element-567">
                  {step.phase}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed bg-white/80 backdrop-blur-sm p-2 rounded-lg" data-id="element-568">
                  {step.action}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </div>;
}